/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import React from 'react'
import getSvgProps from '../get-svg-props'
function AgendaIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 6.5a1.5 1.5 0 0 0-3 0V8H9a4 4 0 0 0-4 4v11a4 4 0 0 0 4 4h13a4 4 0 0 0 4-4V12a4 4 0 0 0-4-4h-1V6.5a1.5 1.5 0 0 0-3 0V8h-5V6.5Zm5 5v-1h-5v1a1.5 1.5 0 0 1-3 0v-1H9A1.5 1.5 0 0 0 7.5 12v3h16v-3a1.5 1.5 0 0 0-1.5-1.5h-1v1a1.5 1.5 0 0 1-3 0Zm5.5 6h-16V23A1.5 1.5 0 0 0 9 24.5h13a1.5 1.5 0 0 0 1.5-1.5v-5.5Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
AgendaIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-agenda',
}

function ArrowIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M16.5 31 25 0H8l8.5 31Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
ArrowIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-arrow',
}

function CloseIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M9.161 7.44A1.5 1.5 0 1 0 7.04 9.56l6.617 6.618-7.218 7.217a1.5 1.5 0 1 0 2.122 2.122l7.217-7.218 6.818 6.818a1.5 1.5 0 0 0 2.121-2.121L17.9 16.178l6.217-6.218a1.5 1.5 0 1 0-2.121-2.12l-6.218 6.216L9.161 7.44Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
CloseIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-close',
}

function DividerIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M16.5 32 18 0h-3l1.5 32Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
DividerIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-divider',
}

function DropdownIcon(props) {
  const svgWidth = "14"
  const svgHeight = "9"
  const svgPath = "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.53.261a1 1 0 0 1 .066 1.413l-5.19 5.69a2 2 0 0 1-2.955 0L.26 1.674A1 1 0 1 1 1.74.326l5.19 5.69 5.189-5.69A1 1 0 0 1 13.53.261Z\" fill=\"#333\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
DropdownIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-dropdown',
}

function ErrorIcon(props) {
  const svgWidth = "16"
  const svgHeight = "16"
  const svgPath = "<circle cx=\"8\" cy=\"8\" r=\"8\"/><path d=\"M9.06 4H6.94v2.55l.23 2.78h1.66l.23-2.78ZM8 10c-.72 0-1.15.38-1.15 1s.42 1 1.15 1 1.17-.37 1.17-1-.46-1-1.17-1Z\" fill=\"#fff\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
ErrorIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-error',
}

function FilterIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M26.574 5.226h3.878a1.548 1.548 0 1 1 0 3.097h-3.878a4.647 4.647 0 0 1-8.761 0H1.548a1.548 1.548 0 0 1 0-3.097h16.265a4.647 4.647 0 0 1 8.761 0Zm3.878 12.387a1.548 1.548 0 1 0 0-3.097H14.187a4.647 4.647 0 0 0-8.761 0H1.548a1.548 1.548 0 0 0 0 3.097h3.878a4.647 4.647 0 0 0 8.761 0h16.265ZM32 25.355c0 .855-.693 1.548-1.548 1.548h-3.878a4.647 4.647 0 0 1-8.761 0H1.548a1.548 1.548 0 1 1 0-3.096h16.265a4.647 4.647 0 0 1 8.761 0h3.878c.855 0 1.548.693 1.548 1.548Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
FilterIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-filter',
}

function InfoIcon(props) {
  const svgWidth = "16"
  const svgHeight = "16"
  const svgPath = "<circle cx=\"8\" cy=\"8\" r=\"8\"/><path d=\"M8 5.63a1.46 1.46 0 0 1-.91-.23.92.92 0 0 1-.28-.74.91.91 0 0 1 .28-.75A1.4 1.4 0 0 1 8 3.67a1.35 1.35 0 0 1 .9.24.92.92 0 0 1 .29.75.92.92 0 0 1-.29.74 1.41 1.41 0 0 1-.9.23Zm1 6.7H7v-6h2Z\" fill=\"#fff\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
InfoIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-info',
}

function LoaderIcon(props) {
  const svgWidth = "100"
  const svgHeight = "100"
  const svgPath = "<path d=\"M0 0h100v100H0z\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
LoaderIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-loader',
}

function LogoIcon(props) {
  const svgWidth = "130"
  const svgHeight = "60"
  const svgPath = "<path d=\"M5.01 59.156 0 0h9.084l1.613 34.31c.17 3.83.339 8.366.51 13.606h1.018c.17-4.396.424-8.929.765-13.606L15.152 0h4.202l-4.839 59.156H5.01Zm17.656-1.478c-1.642-1.55-2.46-3.915-2.46-7.1V23.41c0-3.183.82-5.558 2.46-7.119 1.642-1.563 4.133-2.346 7.47-2.346 3.339 0 5.88.783 7.536 2.346 1.655 1.563 2.482 3.936 2.482 7.119v27.168c0 3.185-.83 5.55-2.483 7.1C36.017 59.224 33.505 60 30.138 60c-3.368 0-5.829-.775-7.471-2.322Zm8.788-2.917V19.266c0-1.409-.424-2.112-1.275-2.112-.85 0-1.274.703-1.274 2.112v35.495c0 1.35.424 2.027 1.274 2.027.851 0 1.275-.676 1.275-2.027Zm11.718 4.395V14.79h8.193a34.959 34.959 0 0 1-.107 3.57c-.098 1.253-.287 2.978-.573 5.176l.68.17c.621-2.732 1.195-4.746 1.72-6.041.523-1.296 1.11-2.182 1.76-2.663.65-.48 1.57-.775 2.76-.889l.932 10.1c-2.093.337-3.58.74-4.458 1.204-.877.465-1.463 1.205-1.76 2.22-.298 1.013-.445 2.69-.445 5.026v26.494h-8.702Zm19.024-1.606c-1.499-1.635-2.25-4.17-2.25-7.606v-4.69l8.107-.802v9.213c0 1.24.099 2.083.296 2.534.198.452.496.677.894.677.509 0 .869-.337 1.082-1.014.213-.677.317-1.775.317-3.296 0-2.31-.282-4.38-.848-6.21-.565-1.832-1.57-3.804-3.013-5.917l-2.759-4.056c-1.416-2.083-2.434-4.084-3.056-6a18.796 18.796 0 0 1-.933-5.832c0-3.69.75-6.38 2.25-8.068 1.502-1.689 3.907-2.535 7.218-2.535s5.687.86 7.215 2.577c1.528 1.717 2.277 4.395 2.25 8.026l-.042 2.917-8.404.802v-7.987c0-1.24-.086-2.091-.256-2.556-.171-.464-.44-.698-.808-.698-.454 0-.77.337-.955 1.014-.184.677-.274 1.789-.274 3.34 0 2.197.24 4.055.72 5.576.48 1.52 1.386 3.211 2.716 5.069l2.717 3.803c1.528 2.142 2.68 4.247 3.461 6.317.779 2.07 1.168 4.512 1.168 7.331 0 3.663-.779 6.333-2.336 8.008C75.116 59.16 72.642 60 69.245 60c-3.2 0-5.548-.817-7.047-2.45h-.002Zm22.401.104c-1.173-1.282-1.76-3.161-1.76-5.64V18.253h-3.226v-3.464h3.227v-3.464l8.7-9.34V14.79h4.71v3.464h-4.71V51.93c0 1.295.565 1.943 1.698 1.943s2.151-.295 3.055-.887l-.128 2.83c-1.3 2.508-3.466 3.76-6.495 3.76-2.207 0-3.898-.64-5.074-1.921h.003Zm22.445-46.331H98.34V2.914h8.702v8.409Zm0 47.83H98.34V14.79h8.702v44.367-.003Zm3.009.003V14.789h7.98c.112 1.014-.142 2.79-.765 5.324l.679.21c.51-1.999 1.31-3.493 2.397-4.478 1.091-.984 2.584-1.478 4.48-1.478 1.754 0 3.055.486 3.906 1.457.848.972 1.274 2.458 1.274 4.46v38.872h-8.7V20.45c0-.873-.24-1.31-.722-1.31-.566 0-1.013.549-1.339 1.647-.325 1.1-.488 2.633-.488 4.605v33.761h-8.702v.003Z\" fill=\"#fff\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
LogoIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-logo',
}

function MenuIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<rect x=\"25\" y=\"17\" width=\"19\" height=\"3\" rx=\"1.5\" transform=\"rotate(-180 25 17)\" fill=\"currentColor\"/><rect x=\"25\" y=\"11\" width=\"19\" height=\"3\" rx=\"1.5\" transform=\"rotate(-180 25 11)\" fill=\"currentColor\"/><rect x=\"25\" y=\"23\" width=\"19\" height=\"3\" rx=\"1.5\" transform=\"rotate(-180 25 23)\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
MenuIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-menu',
}

function SearchIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.5 6a8.5 8.5 0 1 0 4.3 15.833 1.5 1.5 0 0 0 .26.349l3.536 3.536a1.5 1.5 0 1 0 2.122-2.122l-3.536-3.535a1.491 1.491 0 0 0-.145-.128A8.5 8.5 0 0 0 14.5 6Zm-5.95 8.5a5.95 5.95 0 1 1 11.9 0 5.95 5.95 0 0 1-11.9 0Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
SearchIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-search',
}

function SuccessIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16Z\" fill=\"currentColor\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24.347 8.765c.682.56.782 1.566.222 2.248L14.117 23.751l-7.132-5.884a1.597 1.597 0 1 1 2.032-2.464l4.663 3.846L22.1 8.987a1.597 1.597 0 0 1 2.247-.222Z\" fill=\"#fff\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
SuccessIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-success',
}

function TriangleIcon(props) {
  const svgWidth = "18"
  const svgHeight = "22"
  const svgPath = "<path d=\"M18 11 0 21.392V.608L18 11Z\" fill=\"#fff\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
TriangleIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-triangle',
}

function VisitIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.5 11c.828 0 1.5.56 1.5 1.25v2.5c0 .69-.672 1.25-1.5 1.25s-1.5-.56-1.5-1.25v-2.5c0-.69.672-1.25 1.5-1.25Z\" fill=\"currentColor\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.55 16.453c.692-1.53.95-2.529.95-2.981 0-2.737-2.23-4.972-5-4.972s-5 2.235-5 4.972c0 .452.258 1.45.95 2.98.646 1.431 1.53 3.025 2.442 4.542.552.917 1.105 1.79 1.608 2.562a84.565 84.565 0 0 0 1.608-2.562c.913-1.517 1.796-3.111 2.442-4.541Zm-2.538 9.351C19.202 22.522 23 16.408 23 13.472 23 9.345 19.642 6 15.5 6 11.358 6 8 9.345 8 13.472c0 2.936 3.798 9.05 5.988 12.332\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
VisitIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-visit',
}

function VorstinFacebookIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<g clip-path=\"url(#clip0_835_2917)\"><path d=\"M32 16.098C32 7.208 24.837 0 16 0S0 7.207 0 16.098C0 24.133 5.85 30.792 13.5 32V20.751H9.437v-4.653H13.5V12.55c0-4.034 2.389-6.263 6.043-6.263 1.75 0 3.582.315 3.582.315v3.961h-2.017c-1.988 0-2.608 1.241-2.608 2.515v3.019h4.438l-.71 4.653H18.5V32C26.15 30.792 32 24.133 32 16.098Z\" fill=\"currentColor\"/></g>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
VorstinFacebookIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-vorstin-facebook',
}

function VorstinInstagramIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<g clip-path=\"url(#a)\" fill=\"currentColor\"><path d=\"M15.878 2.86c4.242 0 4.744.018 6.413.092 1.55.068 2.388.329 2.946.546a4.91 4.91 0 0 1 1.823 1.185c.559.558.9 1.085 1.185 1.823.217.558.477 1.402.546 2.946.074 1.675.093 2.177.093 6.413 0 4.243-.019 4.745-.093 6.413-.069 1.551-.329 2.388-.546 2.947a4.91 4.91 0 0 1-1.185 1.823 4.88 4.88 0 0 1-1.823 1.185c-.558.217-1.402.477-2.946.545-1.675.075-2.177.093-6.413.093-4.243 0-4.745-.018-6.413-.093-1.551-.068-2.388-.328-2.946-.545a4.91 4.91 0 0 1-1.824-1.185 4.884 4.884 0 0 1-1.185-1.823c-.217-.559-.477-1.402-.545-2.947-.075-1.674-.093-2.177-.093-6.413 0-4.242.018-4.744.093-6.413.068-1.55.328-2.388.545-2.946a4.91 4.91 0 0 1 1.185-1.823A4.884 4.884 0 0 1 6.52 3.498c.558-.217 1.401-.478 2.946-.546 1.668-.074 2.17-.093 6.413-.093Zm0-2.86c-4.31 0-4.85.019-6.544.093C7.647.167 6.488.44 5.483.831c-1.048.41-1.935.949-2.816 1.836-.887.88-1.427 1.768-1.836 2.81C.441 6.487.167 7.64.093 9.328c-.074 1.7-.093 2.24-.093 6.55s.019 4.85.093 6.543c.074 1.687.347 2.847.738 3.852.41 1.048.949 1.935 1.836 2.816a7.76 7.76 0 0 0 2.81 1.83c1.01.39 2.164.663 3.851.737 1.693.075 2.233.093 6.543.093 4.311 0 4.85-.018 6.544-.093 1.687-.074 2.847-.347 3.851-.738a7.762 7.762 0 0 0 2.81-1.83 7.762 7.762 0 0 0 1.83-2.81c.39-1.01.663-2.164.738-3.85.074-1.694.093-2.233.093-6.544 0-4.31-.019-4.85-.093-6.543-.075-1.687-.347-2.847-.738-3.852a7.436 7.436 0 0 0-1.817-2.822 7.763 7.763 0 0 0-2.81-1.83C25.268.447 24.114.174 22.427.1c-1.7-.08-2.239-.1-6.55-.1Z\"/><path d=\"M15.878 7.722a8.158 8.158 0 0 0-8.156 8.156 8.158 8.158 0 0 0 8.156 8.156 8.158 8.158 0 0 0 8.155-8.156 8.158 8.158 0 0 0-8.155-8.156Zm0 13.446a5.291 5.291 0 1 1 .001-10.582 5.291 5.291 0 0 1-.001 10.582ZM26.26 7.4a1.904 1.904 0 1 1-3.809-.002 1.904 1.904 0 0 1 3.81.001Z\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h32v32H0z\"/></clipPath></defs>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
VorstinInstagramIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-vorstin-instagram',
}

function VorstinLinkedinIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M29.631 1H2.363C1.056 1 0 1.999 0 3.234V29.76C0 30.995 1.056 32 2.362 32h27.27C30.936 32 32 30.995 32 29.766V3.234C32 2 30.937 1 29.631 1ZM9.494 27.417h-4.75V12.619h4.75v14.798ZM7.119 10.603c-1.525 0-2.756-1.193-2.756-2.664 0-1.472 1.23-2.664 2.756-2.664 1.518 0 2.75 1.192 2.75 2.664 0 1.465-1.232 2.664-2.75 2.664Zm20.15 16.814h-4.744v-7.193c0-1.714-.031-3.924-2.469-3.924-2.469 0-2.844 1.871-2.844 3.802v7.315h-4.737V12.619h4.55v2.022h.063c.63-1.162 2.18-2.391 4.487-2.391 4.806 0 5.694 3.063 5.694 7.047v8.12Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
VorstinLinkedinIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-vorstin-linkedin',
}

function VorstinSpotifyIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<g clip-path=\"url(#a)\"><path d=\"M16 0C7.164 0 0 7.163 0 16s7.164 16 16 16 16-7.163 16-16S24.836 0 16 0Zm7.806 23.065a1.396 1.396 0 0 1-1.896.534 16.569 16.569 0 0 0-6.475-2.039 16.657 16.657 0 0 0-6.768.701 1.392 1.392 0 0 1-.846-2.65 19.37 19.37 0 0 1 7.895-.819 19.366 19.366 0 0 1 7.554 2.38 1.39 1.39 0 0 1 .536 1.893Zm1.915-4.86a1.39 1.39 0 0 1-1.876.591 21.748 21.748 0 0 0-7.889-2.353 21.683 21.683 0 0 0-8.254.735 1.39 1.39 0 0 1-.771-2.674 24.513 24.513 0 0 1 9.307-.83 24.538 24.538 0 0 1 8.894 2.655c.679.355.946 1.195.59 1.876Zm.694-4.043a1.4 1.4 0 0 1-.621-.146 26.882 26.882 0 0 0-9.319-2.69 26.825 26.825 0 0 0-9.687.766 1.391 1.391 0 0 1-.715-2.69 29.655 29.655 0 0 1 10.686-.844 29.625 29.625 0 0 1 10.276 2.967 1.392 1.392 0 0 1-.62 2.637Z\" fill=\"currentColor\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h32v32H0z\"/></clipPath></defs>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
VorstinSpotifyIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-vorstin-spotify',
}

function VorstinYoutubeIcon(props) {
  const svgWidth = "32"
  const svgHeight = "32"
  const svgPath = "<path d=\"M31.681 9.963s-.312-2.255-1.275-3.245c-1.218-1.303-2.581-1.31-3.206-1.386C22.725 5 16.006 5 16.006 5h-.012S9.275 5 4.8 5.332c-.625.077-1.987.083-3.206 1.386C.63 7.708.325 9.963.325 9.963S0 12.613 0 15.258v2.478c0 2.644.319 5.295.319 5.295s.312 2.255 1.268 3.245c1.22 1.302 2.82 1.258 3.532 1.398C7.68 27.924 16 28 16 28s6.725-.013 11.2-.338c.625-.077 1.988-.084 3.206-1.386.963-.99 1.275-3.245 1.275-3.245S32 20.387 32 17.736v-2.478c0-2.645-.319-5.295-.319-5.295ZM12.694 20.744v-9.19l8.643 4.61-8.643 4.58Z\" fill=\"currentColor\"/>"
  return <svg {...getSvgProps({...props, svgWidth, svgHeight, svgPath})} />
}
VorstinYoutubeIcon.defaultProps = {
  defaultClassName: 'eagerlyicon  eagerlyicon-vorstin-youtube',
}

export {
  AgendaIcon,
  ArrowIcon,
  CloseIcon,
  DividerIcon,
  DropdownIcon,
  ErrorIcon,
  FilterIcon,
  InfoIcon,
  LoaderIcon,
  LogoIcon,
  MenuIcon,
  SearchIcon,
  SuccessIcon,
  TriangleIcon,
  VisitIcon,
  VorstinFacebookIcon,
  VorstinInstagramIcon,
  VorstinLinkedinIcon,
  VorstinSpotifyIcon,
  VorstinYoutubeIcon
}